import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
import * as XLSX from "xlsx";
import FILE from "../../../assets/files/บริษัทจำหน่าย.xlsx";
export default class Companies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      modal_import: false,

      filter_search: "",
      filter_warehouse_id: "",

      data: [],
      count: 10,
      data_warehouse: [],

      id: "",
      uid: "",
      warehouse_id: "",
      company_name: "",
      tax_number: "",
      address: "",
      phone: "",
      email: "",

      import_data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count, data_warehouse;
    loading(true);
    let [result, result_warehouse] = await Promise.all([GET("admin/setting/companies/list", { page: page, data_search: this.state.filter_search, warehouse_id: this.state.filter_warehouse_id || "" }), GET("admin/setting/warehouses/list", { page: 0, data_search: "" })]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({ value: e.uid, label: e.name }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, warehouse_id, company_name, tax_number, address, phone, email, data_warehouse } = this.state;
    if (!warehouse_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    } else if (!company_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อบริษัท");
      return;
    }

    loading(true);
    let body = {
      warehouse_id,
      company_name,
      tax_number,
      address,
      phone,
      email,
    };

    let result = !uid ? await POST("admin/setting/companies/create", body) : await PUT("admin/setting/companies/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
      let result = await DELETE("admin/setting/companies/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };

  handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;

      // อ่านไฟล์ Excel
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // อ่านแค่ sheet แรก
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // แปลง sheet เป็น JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      this.setState({
        import_data: jsonData.map((e) => ({
          warehouse_id: this.state.data_warehouse.find((w) => w.label === e["คลังสินค้า"])?.value || "",
          company_name: e["ชื่อบริษัท"],
          tax_number: e["เลขที่ผู้เสียภาษี"],
          address: e["ที่อยู่"],
          phone: e["เบอร์โทร"].replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("+660", "0").replaceAll("+66", "0"),
          email: e["อีเมล"],
        })),
        modal_import: true,
      });
      document.getElementById("file").value = "";
      document.getElementById("file").files = null;
    };

    reader.readAsBinaryString(file);
  };
  // 👉 helper: แบ่ง array เป็นก้อนละ size ชุด
  chunkBy = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size));

  Import = async () => {
    const { import_data } = this.state;
    const CHUNK_SIZE = 30;
    const batches = this.chunkBy(import_data, CHUNK_SIZE);
    const allResults = [];

    try {
      // 🌀 วนทีละ batch
      for (const batch of batches) {
        const batchResult = await Promise.all(
          batch.map(async (item) => {
            try {
              const res = await POST("admin/setting/companies/create", {
                warehouse_id: item.warehouse_id,
                company_name: item.company_name,
                tax_number: item.tax_number,
                address: item.address,
                phone: item.phone,
                email: item.email,
              });
              return res;
            } catch (err) {
              return { status: false, message: err.message || "Unknown error" };
            }
          })
        );
        allResults.push(...batchResult); // รวมผลแต่ละ batch
      }

      // ✅ ประเมินผลรวม
      if (allResults.every((r) => r && r.status === true)) {
        alert("#", "success");
      } else {
        const failMsgs = allResults.filter((r) => !r.status).map((r) => r.message);
        alert("", "warning", "แจ้งเตือน", "บางรายการนำเข้าไม่สำเร็จ:\n" + failMsgs[0]);
      }
    } catch (error) {
      console.error("Import error:", error);
      alert("", "warning", "แจ้งเตือน", "เกิดข้อผิดพลาดระหว่างนำเข้า");
    }
  };
  render() {
    const { modal_create, modal_update, modal_import, filter_search, filter_warehouse_id, data, count, data_warehouse, id, uid, warehouse_id, company_name, tax_number, address, phone, email, import_data } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <input hidden id="file" type="file" accept=".xlsx, .xls" onChange={(event) => this.handleFileUpload(event)} />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">บริษัทที่จำหน่าย</h4>
              <div className="d-flex">
                <div className="companies.create">
                  <button
                    className="btn btn-info px-3 ms-2 mb-0"
                    onClick={async () => {
                      document.getElementById("file").click();
                    }}
                  >
                    import excel
                  </button>
                  <div className="hpx-10 px-2">
                    <a className="text-10 px-2 text-primary" style={{ marginTop: -4 }} href={FILE} download="template บริษัท.xlsx">
                      template บริษัท.xlsx
                    </a>
                  </div>
                </div>
                <div>
                  <button
                    className="btn btn-dark px-3 ms-2 mb-2 companies.create"
                    onClick={async () => {
                      this.setState({ id: "", uid: "", warehouse_id: "", company_name: "", tax_number: "", address: "", phone: "", email: "", modal_create: true });
                    }}
                  >
                    เพิ่มรายการ
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">ชื่อบริษัท</td>
                    <td className="text-nowrap">เลขที่ผู้เสียภาษี</td>
                    <td className="text-nowrap">ที่อยู่</td>
                    <td className="text-nowrap">เบอร์โทรศัพท์</td>
                    <td className="text-nowrap">อีเมล</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">{item.warehouse?.name || "-"}</td>
                      <td className="text-nowrap">{item.company_name || "-"}</td>
                      <td className="text-nowrap">{item.tax_number || "-"}</td>
                      <td className="text-nowrap">{item.address || "-"}</td>
                      <td className="text-nowrap">{item.phone || "-"}</td>
                      <td className="text-nowrap">{item.email || "-"}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="companies.update"
                            type="update"
                            onClick={() => {
                              this.setState({ ...item, warehouse_id: item?.warehouse?.uid || "", modal_update: true });
                            }}
                          />
                          <BtnIcon
                            className="companies.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}บริษัทที่จำหน่าย</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ warehouse_id: e });
                }}
                value={warehouse_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อบริษัท{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อบริษัท..."
                onChange={(e) => {
                  this.setState({ company_name: e.target.value });
                }}
                value={company_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">เลขที่ผู้เสียภาษี</div>
              <input
                type="text"
                className="form-control"
                placeholder="เลขที่ผู้เสียภาษี..."
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ tax_number: e.target.value });
                }}
                value={tax_number}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ที่อยู่</div>
              <textarea
                className="form-control"
                placeholder="ที่อยู่..."
                rows={5}
                onChange={(e) => {
                  this.setState({ address: e.target.value });
                }}
                value={address}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">เบอร์โทร</div>
              <input
                type="text"
                className="form-control"
                placeholder="เบอร์โทร..."
                maxLength={10}
                onChange={(e) => {
                  if (!float(e.target.value)) return;
                  this.setState({ phone: e.target.value });
                }}
                value={phone}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">อีเมล</div>
              <input
                type="text"
                className="form-control"
                placeholder="อีเมล..."
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                value={email}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal show={modal_import} onHide={() => this.setState({ modal_import: false })} size="lg">
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายการนำเข้า</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">ชื่อบริษัท</td>
                    <td className="text-nowrap">เลขที่ผู้เสียภาษี</td>
                    <td className="text-nowrap">ที่อยู่</td>
                    <td className="text-nowrap">เบอร์โทร</td>
                    <td className="text-nowrap">อีเมล</td>
                  </tr>
                </thead>
                <tbody>
                  {import_data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.warehouse_id ? data_warehouse.find((w) => w.value === item.warehouse_id)?.label : "-"}</td>
                      <td className="text-nowrap">{item.company_name || "-"}</td>
                      <td className="text-nowrap">{item.tax_number || "-"}</td>
                      <td className="text-nowrap">{item.address || "-"}</td>
                      <td className="text-nowrap">{item.phone || "-"}</td>
                      <td className="text-nowrap">{item.email || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.Import();
                }}
              >
                นำเข้า
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_import: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
